/**
 * SxaScoreInputSliderTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Slider from '@material-ui/lab/Slider';
import axios from "axios";

const theme = createMuiTheme({
    overrides: {
        MuiSlider: {
            trackBefore: { backgroundColor: '#FF9519', height: '6px'},
            thumb: { backgroundColor: '#FF7A19', height: '20px', width: '20px'},
            trackAfter: { height: '6px'},
        },
    },
    typography: {
        useNextVariants: true,
    }
});

class SxaScoreInputSliderTile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value : this.props.q.score,
            dragended: false,
            stateChanged: false
        };
    }

    changeQuestion(newQ) {
        //console.log("Question input slider was changed; new Q = " + newQ.oid);

        // Force re-render
        this.setState( state => ({ value : newQ.score }) );
    }

    handleChange = (event, value) => {
        var eventVal = value;
        //console.log("Q " + this.props.q.oid + " changed; event value = " + eventVal +
        //    "; state value = " + this.state.value);
        this.setState({ value: value, stateChanged: true});
        //console.log("Q " + this.props.q.oid + " changed; value = " + this.state.value);

        var roundedScore;

        // if dragended flag is set then reset it
        if (this.state.dragended === true) {
            //console.log("Q " + this.props.q.oid + " changed; resetting dragended flag");

            // Send the state value to the server?
            roundedScore = Math.round(eventVal);

            console.log("Send Slider Value " + Math.round(eventVal) + " to server in handleChange()");
            ;
            // Reset the stateChanges and dragended flags (in the response handler?)
            this.setState({ stateChanged: false });
            this.setState({ dragended: false });

            var url = 'api/assessment/setQScoreWithGet?qid=' + this.props.q.oid + '&qscore=' + roundedScore;
            axios.get(url)
                .then(response => {
                    //console.log(response.data);

                    // Refresh the score display
                    // Update the Q object
                    // Option: use the confirmed score from the server? No UFN
                    this.props.q.score = roundedScore;

                    console.log("Q " + this.props.q.oid + " refreshing Q score post-send in handleChange()");

                    // Signal the Q container - callback function
                    this.props.refreshQScore(true, roundedScore);
                })
                .catch(err => console.error(err))
        }
        else {
            // Change made below to use eventVal instead of state.value correctly picks up
            // the clicked value
            roundedScore = Math.round(eventVal);

            this.props.q.score = roundedScore;

            // Signal the Q container - callback function
            this.props.refreshQScore(false, roundedScore);
        }
    };

    handleDragEnd = () => {
        //console.log("Q " + this.props.q.oid + " drag end; state value = " + this.state.value +
        //    "; stateChanged = " + this.state.stateChanged);

        // Check for state change changed - slider was dragged:
        if (this.state.stateChanged === true) {
            // Set the score on the current Q on the Assessment
            var roundedScore = Math.round(this.state.value);

            console.log("Send Slider Value " + roundedScore + " to server in handleDragEnd()");

            // Reset the stateChanges and dragended flags (in the response handler?)
            this.setState({ stateChanged: false });
            this.setState({ dragended: false });

            // FIXME - change to sxa/v1/assessment
            // FIXME - use GET instead of POST to workaround CORS bug in server
            // Replaced Axios version:
            var url = 'api/assessment/setQScoreWithGet?qid=' + this.props.q.oid + '&qscore=' + roundedScore;
            axios.get(url)
                .then(response => {
                    //console.log(response.data);

                    // Refresh the score display
                    // Update the Q object
                    // Option: use the confirmed score from the server? No UFN
                    this.props.q.score = roundedScore;

                    console.log("Q " + this.props.q.oid + " refreshing Q score post-send in handleDragEnd()");

                    // Signal the Q container - callback function
                    this.props.refreshQScore(true, roundedScore);
                })
                .catch(err => console.error(err))
        }
        else {
            // Set dragended flag
            this.setState({ dragended: true });
        }
    };

    render() {
        return (
            <MuiThemeProvider theme={theme}>
            <React.Fragment>
                {this.props.q ? (
                    <Slider
                        ref={(qslider) => { this.qslider = qslider; }}
                        min={0}
                        max={100}
                        step={5}
                        value={this.state.value}
                        aria-labelledby="label"
                        onChange={this.handleChange}
                        onDragEnd={this.handleDragEnd}
                        style={{ paddingBottom: '0px' }}
                    />
                ) : "No Question found"}
            </React.Fragment>
            </MuiThemeProvider>
        );
    }
}

export default SxaScoreInputSliderTile;